// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import './BashCodeBlock.scss';

const bem = bemify('bash-code-block');

type LineItem = {
  content: string,
  isComment: boolean,
  isCommand: boolean,
};

type Props = {
  lines: Array<LineItem>,
};

const BashCodeBlock = (props: Props) => {
  const { lines } = props;
  const linesToRender = lines.map((line, index) => (
    <span
      className={bem(
        '__line',
        toModifiers({
          comment: line.isComment,
          command: line.isCommand,
        })
      )}
      key={index}
    >
      {line.content}
    </span>
  ));
  return (
    <div className={bem()}>
      <pre className={bem('__pre')}>
        <code className={bem('__code')}>{linesToRender}</code>
      </pre>
    </div>
  );
};

export default BashCodeBlock;
